<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            <template v-if="creditBureau.officers">
                <strong>Attn:</strong> {{ creditBureau.officers }} <br />
            </template>
        </p>
        <p> To whom it may concern you have violated my rights under the FCRA.</p>
        <p class="letter-content">
            On <strong>{{ originalDisputeDate != null ? moment(originalDisputeDate).format('LL'):'(Insert Date)' }}</strong> I sent a dispute letter to you, disputing the account(s) listed below.
            It was received on <strong>{{ dateRecievedLetter != null ? moment(dateRecievedLetter).format('LL'):'(Insert Date)' }}</strong> by your company. And the notice of dispute was not entered
            within the 30 day time frame, and because of this you have failed in your duty as the furnisher of this information, and you are in violation of section 623(a)(2).

        </p>

        <P class="letter-content">
            Enclosed are the accounts that you failed to mark a "Notice of Dispute".  Please delete these accounts from my credit report.
        </P>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalDisputeDate:{
                type:String
            },
            dateRecievedLetter:{
                type:String
            }

        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>
